const fontFamilies = [
  'notosansl',
  'notosans',
  'notosansb',
  'chosunsm',
  'uhbeegenwoo',
  'midschool',
  'yeoseel',
  'yeosee',
  'yeoseeb',
  'yangpyeongl',
  'yangpyeong',
  'yangpyeongb',
  'dosmyungjo',
  'fatherlove',
  'mapobackpack',
  'chosunkm',
  'chosunnm',
  'chosuncentennial'
];

export { fontFamilies };
